import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { AppComponent } from '../../app.component';
import { NgxSpinnerService } from "ngx-spinner";
import { CookieService } from 'ngx-cookie-service';
import swal from 'sweetalert';
import * as moment from 'moment';
/*
const dateNow = new Date();
//dateNow.setMinutes(dateNow.getMinutes() + 1);
dateNow.setHours(dateNow.getHours() + 1);
*/
@Component({
  selector: 'app-consulta',
  templateUrl: './consulta.component.html',
  styleUrls: ['./consulta.component.css']
})

export class ConsultaComponent implements OnInit {
  url;
  url_pdf;
  url_app;
  url_envio_ecommerce;
  url_system;
  
  mostrar_adeudo;
  mostrar_opc_pago;

  result_temp: any[] = [];
  datos_adeudos: any[] = [];
  datos_bbva: any[] = [];
  datos_ecommerce: any[] = [];  
  datos_mit: any[] = [];
  datos_netpay: any[] = [];  
  pagos: any[] = [];

  ultima_cuenta;
  btn_consultar;
  btn_recibo;
  
  public respuesta;
  marcar_captcha;

  ClaveCatastral;
  IdCuenta;
  Calle;
  Colonia;
  NoInterior;
  NoExterior;
  MtsTerreno;
  MtsConstruccion;
  ValorTerreno;
  ValorConstruccion;
  ValorCatastral;
  LugarPago;
  fecha_limite;
  amount;
  id;
  message;

  MensajeAfectacion;
  MensajeSubsidios;
  MensajeFechaLimite;
  MensajePago;
  MensajeSweet;

  web_status;
  /*
  depto_dev;
  tel_help_dev;
  no_procede_menos_1;
  no_procede_menos_2;
  no_procede_menos_3;
  no_procede_menos_4;
  no_procede_menos_6;
  no_procede_menos_8;
  no_procede_menos_9;
  */
  mensaje_no_procede_title;
  mensaje_no_procede_body;
  mensaje_mantenimiento;
  /*
  hora_inicio_ampm;
  hora_inicio_hrs;
  hora_consulta_ampm;
  hora_consulta_hrs;
  mensaje_horario_procesando_pagos;
  mensaje_horario_aplicacion_pagos;
  mensaje_horario_servicio;
  */
  hora_actual;
  hora_envio;
  hora_inicial_consulta;
  hora_limite_consulta;
  hora_caducidad;
  icebl;
  origen;
  s_transm;
  linea_captura;
  importe;
  mp_signature;

  presupuesto;
  presupuesto_params_encriptado;
  presupuesto_url;
  url_valida_presupuesto_participativo;
  params_ventana_presupuesto_participativo;

  formConsulta: FormGroup;
  
  @ViewChild('recaptcha') recaptchaElement: ElementRef;

  constructor(private spinner: NgxSpinnerService, private _formBuilder: FormBuilder, private http: HttpClient, public global: AppComponent, private cookieService: CookieService) {
    this.url = global.url;
    this.url_pdf = global.url_pdf;
    this.url_app = global.url_app;
    this.url_envio_ecommerce = global.url_envio_ecommerce;
    this.url_system = global.url_system;
    this.btn_consultar = true;
    this.marcar_captcha = false;
    this.params_ventana_presupuesto_participativo = global.params_ventana_presupuesto_participativo;
    
    this.formConsulta = this._formBuilder.group({
      recaudadora: ['', Validators.required],
      tipo: ['', Validators.required],
      cuenta: ['', Validators.required],
      recaptcha: ['', Validators.required],
      correo: ['']
    });
  }

  ngOnInit(): void {
    /*
    if(this.global.web_status==='M'){
      this.global.mostrar = false;
      this.global.mostrar_mantenimiento = true;
    }
    
    this.global.validaHoraServicio();
    */
  }//ngOnInit(): void {

  ngAfterContentInit() {
    if(this.global.web_status==='A'){ 
      this.addRecaptchaScript();
    }
  }//ngAfterContentInit() {

  addRecaptchaScript() {
    window['grecaptchaCallback'] = () => {
      this.renderReCaptcha();
    }
   
    (function(d, s, id, obj){
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) { obj.renderReCaptcha(); return;}
      js = d.createElement(s); js.id = id;
      js.src = "https://www.google.com/recaptcha/api.js?onload=grecaptchaCallback&amp;render=explicit";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'recaptcha-jssdk', this));
  }//addRecaptchaScript() {

  renderReCaptcha() {
    window['grecaptcha'].render(this.recaptchaElement.nativeElement, {
      'sitekey' : '6LelQysaAAAAALZxds3TNyZb3QSe-I322LHx04du',
      'callback': (response) => {
        this.respuesta = response;
        this.btn_consultar = false;
        this.verificar();
      }
    });
  }//renderReCaptcha() {

  verificar(){
    const formDataKey = new FormData();
    formDataKey.append('response', this.respuesta);
    //this.http.post(this.url+'Api/captcha', formDataKey)
    this.http.post(this.url_app+'rest/index.php/captcha/captcha', formDataKey)
    .subscribe( (result: any) => {
      if(result.success){
        this.marcar_captcha = true;
      } else { this.marcar_captcha = false; swal("¡Algo salió mál!", "", "warning"); }
    });
  }//verificar(){
  
  consultar(){ 
    this.limpiar();
    this.global.validaHoraServicio();
    const timeNow = new Date();
    //alert('hora:'+timeNow);
    const formDataKey = new FormData();
    const formData = new FormData();
    formData.append('recaudadora', this.formConsulta.value.recaudadora);
    formData.append('tipo', this.formConsulta.value.tipo);
    formData.append('cuenta', this.formConsulta.value.cuenta);
    formData.append('correo', this.formConsulta.value.correo);
    formData.append('version', this.global.version_system);
    
    if(this.respuesta){//CAPTCHA
      /*
      console.log('this.ultima_cuenta 1:'+this.ultima_cuenta);
      if(this.ultima_cuenta === this.formConsulta.value.recaudadora+this.formConsulta.value.tipo+this.formConsulta.value.cuenta){
        console.log('ok');
        return false;
      }else{
        console.log('bad');
      }
      */
      
      if(this.formConsulta.value.recaudadora){
        if(this.formConsulta.value.tipo){
          if(this.formConsulta.value.cuenta){
            this.spinner.show();
            
            this.ultima_cuenta = this.formConsulta.value.recaudadora+this.formConsulta.value.tipo+this.formConsulta.value.cuenta;
            /*
            console.log('this.ultima_cuenta 2:'+this.ultima_cuenta);

            console.log("localStorage.getItem('response'):");
            console.log(localStorage.getItem('response'));

            console.log('this.formConsulta.value.recaudadora:'+this.formConsulta.value.recaudadora);
            console.log('this.formConsulta.value.tipo:'+this.formConsulta.value.tipo);
            console.log('this.formConsulta.value.cuenta:'+this.formConsulta.value.cuenta);

            console.log('localStorage 1:');
            console.log(localStorage);
            console.log("localStorage.getItem('recaudadora'):"+localStorage.getItem('recaudadora'));
            console.log("localStorage.getItem('tipo'):"+localStorage.getItem('tipo'));
            console.log("localStorage.getItem('cuenta'):"+localStorage.getItem('cuenta'));
            console.log("localStorage.getItem('caducidad_c1'):"+localStorage.getItem('caducidad_c1'));
            ////console.log("localStorage.getItem('caducidad_c2'):"+localStorage.getItem('caducidad_c2'));
            */
            this.hora_caducidad = localStorage.getItem('caducidad_c1');
            //this.hora_caducidad = localStorage.getItem('caducidad_c2');
            /*
            console.log('this.hora_caducidad:'+this.hora_caducidad);            
            console.log('this.global.hora_actual:'+moment(this.global.hora_actual).format());
            console.log(this.global.hora_actual.isBefore(this.hora_caducidad));// true
            */
            /*
            if(this.global.hora_actual.isBefore(this.hora_caducidad)){
              console.log('hora_actual '+moment(this.global.hora_actual).format()+' es menor a hora_caducidad '+this.hora_caducidad);
            }else{
              console.log('hora_actual '+moment(this.global.hora_actual).format()+' es mayor a hora_caducidad '+this.hora_caducidad);
            }
            */

            //if(this.cookieService.get('recaudadora')===this.formConsulta.value.recaudadora && this.cookieService.get('tipo')===this.formConsulta.value.tipo && this.cookieService.get('cuenta')===this.formConsulta.value.cuenta){
            if(this.global.hora_actual.isBefore(this.hora_caducidad) && localStorage.getItem('recaudadora')===this.formConsulta.value.recaudadora && localStorage.getItem('tipo')===this.formConsulta.value.tipo && localStorage.getItem('cuenta')===this.formConsulta.value.cuenta){
              //console.log("local");
              
              this.result_temp = [];
              //this.result_temp = (this.cookieService.get('response')) ? JSON.parse(this.cookieService.get('response')) : [];
              this.result_temp = (localStorage.getItem('response')) ? JSON.parse(localStorage.getItem('response')) : [];
              /*
              console.log('localStorage:');
              console.log(localStorage);
              console.log("localStorage.getItem('response'):");
              console.log(localStorage.getItem('response'));
              */
              if(this.result_temp){
                this.MensajeSweet = (this.MensajeSweet) ? this.MensajeSweet : 'Error';
                if (this.result_temp['status'] === true) {
                  /*
caso
-1 CUENTA INEXISTENTE
0	 CUENTA CON ADEUDO, PROCEDE PAGO
1	 CUENTA PAGADA, NO PROCEDE PAGO
2	 CUENTA EXENTA, NO PROCEDE PAGO
3	 CUENTA CANCELADA
4	 CUENTA BLOQUEADA, PASAR A CATASTRO, NO PROCEDE PAGO
5	 CUENTA PAGADA VIA INTERNET
6	 LA CUENTA TIENE REQUERIMIENTOS SIN PRACTICAR
7	 LA CUENTA TIENE DESCUENTOS ESPECIALES, PROCEDE PAGO
8	 LA CUENTA TIENE CONVENIO DE PAGO
9	 CUENTA BLOQUEADA POR JUICIO DE NULIDAD
10 CUENTA PAGADA ESTABLECIMIENTOS
11 DESCUENTO EXCEDE LIMITE (DEL 18 AL 21 DE NOVIEMBRE); PASAR A JEFATURA DE RECAUDADORA

array('status' => TRUE,  'tipo'=>'5',   'message' => 'CUENTA PREDIAL CON PAGO EN PROCESO DE REVISION',     'data' => ($data_api));//caso 0, 7, 1, 5, 10 PAGO ODOO REGISTRADO, SIN REGISTRO EN INFORMIX
array('status' => TRUE,  'tipo'=>'4',   'message' => 'CUENTA PREDIAL PAGADA, OBTENER RECIBO OFICIAL',      'data' => ($data_api));//caso 0, 7
array('status' => TRUE,  'tipo'=>'3',   'message' => 'CUENTA PREDIAL CON ADEUDO, PROCEDE PAGO',            'data' => ($data_api));//caso 0, 7
array('status' => TRUE,  'tipo'=>'2',   'message' => 'CUENTA PREDIAL CON PAGO EN PROCESO DE REVISION, RE', 'data' => ($data_api));//caso 0, 7
array('status' => TRUE,  'tipo'=>'1',   'message' => 'CUENTA PREDIAL PAGADA',                              'data' => ($data_api));//caso 1, 5, 10
array('status' => TRUE,  'tipo'=>'-1',  'message' => $data_api['EstatusMensaje'],                          'data' => ($data_api));//caso -1	"CUENTA INEXISTENTE"
array('status' => TRUE,  'tipo'=>'-2',  'message' => $data_api['EstatusMensaje'],                          'data' => ($data_api));//caso 2	"CUENTA EXENTA, NO PROCEDE PAGO"
array('status' => TRUE,  'tipo'=>'-3',  'message' => $data_api['EstatusMensaje'],                          'data' => ($data_api));//caso 3	"CUENTA CANCELADA"
array('status' => TRUE,  'tipo'=>'-4',  'message' => $data_api['EstatusMensaje'],                          'data' => ($data_api));//caso 4	"CUENTA BLOQUEADA, PASAR A CATASTRO, NO PROCEDE PAGO"
array('status' => TRUE,  'tipo'=>'-6',  'message' => $data_api['Estatus'],                                 'data' => ($data_api));//caso 6 	"LA CUENTA TIENE REQUERIMIENTOS SIN PRACTICAR"
array('status' => TRUE,  'tipo'=>'-8',  'message' => $data_api['Estatus'],                                 'data' => ($data_api));//caso 8 	"LA CUENTA TIENE CONVENIO DE PAGO"
array('status' => TRUE,  'tipo'=>'-9',  'message' => $data_api['Estatus'],                                 'data' => ($data_api));//caso 9	"CUENTA BLOQUEADA POR JUICIO DE NULIDAD"
array('status' => TRUE,  'tipo'=>'-11', 'message' => $data_api['Estatus'],                                 'data' => ($data_api));//caso 11	"DESCUENTO EXCEDE LIMITE (DEL 18 AL 21 DE NOVIEMBRE); PASAR A JEFATURA DE RECAUDADORA"

array('status' => FALSE, 'tipo'=>'0',  	'message' => 'ERROR PROCESAMIENTO 4',  						                 'data' => array('error' => $data['datos']['error_numero']));
array('status' => FALSE, 'tipo'=>'0',  	'message' => 'ERROR PROCESAMIENTO 3',  						                 'data' => ($data_api));
array('status' => FALSE, 'tipo'=>'0',  	'message' => 'ERROR PROCESAMIENTO 2',  						                 'data' => ($data_api));
array('status' => FALSE, 'tipo'=>'0',   'message' => 'ERROR PROCESAMIENTO 1',  						                 'data' => ($data_api));
array('status' => FALSE, 'tipo'=>'-1',  'message' => 'MANTENIMIENTO PROCESOS', 						                 'data' => ($data_api));
array('status' => FALSE, 'tipo'=>'-2',  'message' => 'PROCESANDO PAGOS',       						                 'data' => ($data_api));
array('status' => FALSE, 'tipo'=>'-3',  'message' => 'MANTENIMIENTO SISTEMAS', 						                 'data' => ($data_api));
array('status' => FALSE, 'tipo'=>'-10', 'message' => 'CUENTA PREDIAL SIN ESTATUS',                         'data' => ($data_api));
                  */
                  //alert('consulta desde localstorage');

                  switch (this.result_temp['tipo']) {
                    case '1'://CUENTA PREDIAL PAGADA
                    case '2'://CUENTA PREDIAL CON PAGO EN PROCESO DE REVISION, RE
                    case '4'://CUENTA PREDIAL PAGADA, OBTENER RECIBO OFICIAL
                    case '5'://CUENTA PREDIAL CON PAGO EN PROCESO DE REVISION
                      if(this.result_temp['data']['presupuesto']){
                        this.presupuesto = this.result_temp['data']['presupuesto'];
                        this.presupuesto_params_encriptado = this.result_temp['data']['presupuesto_params_encriptado'];
                        this.presupuesto_url = this.result_temp['data']['presupuesto_url'];
    
                        this.url_valida_presupuesto_participativo = this.global.url_presupuesto_participativo + this.presupuesto_params_encriptado;
                        //alert('this.presupuesto_url:'+this.presupuesto_url);
                        //alert('this.url_valida_presupuesto_participativo:'+this.url_valida_presupuesto_participativo);
                        //alert('this.params_ventana_presupuesto_participativo:'+this.params_ventana_presupuesto_participativo);
                        if(this.url_valida_presupuesto_participativo == this.presupuesto_url){
                          //window.open(this.presupuesto_url, this.params_ventana_presupuesto_participativo);
                          //setTimeout(() => window.open(this.presupuesto_url, this.params_ventana_presupuesto_participativo), 3000);
                          setTimeout(() => this.global.abre_ventana(this.presupuesto_url));
                          //window.open(this.presupuesto_url, '_self');
                        }
                      }else{//if(this.result_temp['data']['presupuesto']){
                        //alert('no mostrar presupuesto participativo');
                      }//if(this.result_temp['data']['presupuesto']){}else{
                      
                      this.mostrar_adeudo = 'Pagado';
                      this.global.mostrar = true;
                      this.ClaveCatastral = this.result_temp['data']['ClaveCatastral'];
                      this.IdCuenta = this.result_temp['data']['IdCuenta'];
                      this.Calle = this.result_temp['data']['Calle'];
                      this.Colonia = this.result_temp['data']['Colonia'];
                      this.NoExterior = this.result_temp['data']['NoExterior'];
                      //////this.NoExterior = parseInt(this.result_temp['data']['NoExterior']);
                      //////this.NoExterior = this.NoExterior > 0 ? this.NoExterior.toString() : "";
                      this.NoInterior = this.result_temp['data']['NoInterior'];
                      //////this.NoInterior = parseInt(this.result_temp['data']['NoInterior']);
                      //////this.NoInterior = this.NoInterior > 0 ? this.NoInterior.toString() : "";
                      this.MtsTerreno = this.result_temp['data']['MtsTerreno'];
                      this.MtsConstruccion = this.result_temp['data']['MtsConstruccion'];
                      this.ValorTerreno = this.result_temp['data']['ValorTerreno'];
                      this.ValorConstruccion = this.result_temp['data']['ValorConstruccion'];
                      this.ValorCatastral = this.result_temp['data']['ValorCatastral'];
                      this.MensajePago = this.result_temp['data']['EstatusMensaje'];
                      this.LugarPago = this.result_temp['data']['LugarPago'];
                      this.fecha_limite = this.result_temp['data']['fecha_limite'];
                      this.s_transm = this.result_temp['data']['s_transm'];
                      this.linea_captura = this.result_temp['data']['linea_captura'];
                      this.importe = this.result_temp['data']['importe'];
                      this.mp_signature = this.result_temp['data']['mp_signature'];
                      this.pagos = this.result_temp['data']['pagos'];
                    break;
                
                    case '3'://CUENTA PREDIAL CON ADEUDO, PROCEDE PAGO
                      this.mostrar_adeudo = 'Adeudo';
                      this.global.mostrar = true;
                      this.mostrar_opc_pago = true;
                      this.ClaveCatastral = this.result_temp['data']['ClaveCatastral'];
                      this.IdCuenta = this.result_temp['data']['IdCuenta'];
                      this.Calle = this.result_temp['data']['Calle'];
                      this.Colonia = this.result_temp['data']['Colonia'];
                      this.NoExterior = this.result_temp['data']['NoExterior'];
                      //////this.NoExterior = parseInt(this.result_temp['data']['NoExterior']);
                      //////this.NoExterior = this.NoExterior > 0 ? this.NoExterior.toString() : "";
                      this.NoInterior = this.result_temp['data']['NoInterior'];
                      //////this.NoInterior = parseInt(this.result_temp['data']['NoInterior']);
                      //////this.NoInterior = this.NoInterior > 0 ? this.NoInterior.toString() : "";
                      this.MtsTerreno = this.result_temp['data']['MtsTerreno'];
                      this.MtsConstruccion = this.result_temp['data']['MtsConstruccion'];
                      this.ValorTerreno = this.result_temp['data']['ValorTerreno'];
                      this.ValorConstruccion = this.result_temp['data']['ValorConstruccion'];
                      this.ValorCatastral = this.result_temp['data']['ValorCatastral'];
                      this.MensajeAfectacion = this.result_temp['data']['MensajeAfectacion'];
                      this.MensajeSubsidios = this.result_temp['data']['MensajeSubsidios'];
                      this.MensajeFechaLimite = this.result_temp['data']['MensajeFechaLimite'];
                      this.fecha_limite = this.result_temp['data']['fecha_limite'];
                      this.icebl = this.result_temp['data']['icebl'];
                      this.datos_adeudos = this.result_temp['data']['adeudos'];
                      //console.log(typeof this.result_temp['data']['bbva']);
                      /*if (typeof this.result_temp['data']['bbva'] !== 'undefined') {
                        this.datos_bbva = this.result_temp['data']['bbva'];
                      }*//*else{
                        this.datos_bbva = [];
                        delete this.datos_bbva;
                      }*/
                      this.datos_bbva = this.result_temp['data']['bbva'];
                      this.datos_ecommerce = this.result_temp['data']['ecommerce'];
                      this.datos_mit = this.result_temp['data']['mit'];
                      this.datos_netpay = this.result_temp['data']['netpay'];
                      this.amount = this.datos_ecommerce['amount'];
                      this.id = this.datos_ecommerce['id'];
                      this.s_transm = this.result_temp['data']['s_transm'];
                      this.linea_captura = this.result_temp['data']['linea_captura'];
                      this.importe = this.result_temp['data']['importe'];
                      this.mp_signature = this.result_temp['data']['mp_signature'];
                      this.pagos = this.result_temp['data']['pagos'];
                    break;
                
                    case '-1'://CUENTA INEXISTENTE
                      this.global.mostrar = true;
                      this.mostrar_adeudo = 'NoProcede';
                      this.mensaje_no_procede_title = 'Cuenta Predial Inexistente';
                      this.mensaje_no_procede_body = this.global.no_procede_menos_1;
                      //this.MensajeSweet = this.MensajeSweet +' '+ this.result_temp['data']['EstatusMensaje'];
                      //swal("¡Error 1!", this.MensajeSweet, "error");
                
                      /*
                      this.MensajeSweet = this.MensajeSweet +' '+ this.result_temp['data']['EstatusMensaje'];
                      this.mostrar_adeudo = 'Inexistente';
                      this.global.mostrar = false;
                      swal("¡Error 1!", this.MensajeSweet, "error");
                      */
                    break;
                
                    case '-2'://CUENTA EXENTA, NO PROCEDE PAGO
                      this.global.mostrar = true;
                      this.mostrar_adeudo = 'NoProcede';
                      this.mensaje_no_procede_title = 'Cuenta Predial Exenta, no procede pago';
                      this.mensaje_no_procede_body = this.global.no_procede_menos_2;
                      //this.MensajeSweet = this.MensajeSweet +' '+ this.result_temp['data']['EstatusMensaje'];
                      //swal("¡Error 1!", this.MensajeSweet, "error");
                    break;
                
                    case '-3'://CUENTA CANCELADA
                      this.global.mostrar = true;
                      this.mostrar_adeudo = 'NoProcede';
                      this.mensaje_no_procede_title = 'Cuenta Predial Cancelada';
                      this.mensaje_no_procede_body = this.global.no_procede_menos_3;
                      //this.MensajeSweet = this.MensajeSweet +' '+ this.result_temp['data']['EstatusMensaje'];
                      //swal("¡Error 1!", this.MensajeSweet, "error");
                    break;
                
                    case '-4'://CUENTA BLOQUEADA, PASAR A CATASTRO, NO PROCEDE PAGO
                      this.global.mostrar = true;
                      this.mostrar_adeudo = 'NoProcede';
                      this.mensaje_no_procede_title = 'Cuenta Predial Bloqueada, pasar a catastro, no procede pago';
                      this.mensaje_no_procede_body = this.global.no_procede_menos_4;
                      //this.MensajeSweet = this.MensajeSweet +' '+ this.result_temp['data']['EstatusMensaje'];
                      //swal("¡Error 1!", this.MensajeSweet, "error");
                    break;
                
                    case '-6'://LA CUENTA TIENE REQUERIMIENTOS SIN PRACTICAR
                      this.global.mostrar = true;
                      this.mostrar_adeudo = 'NoProcede';
                      this.mensaje_no_procede_title = 'Cuenta Predial tiene requerimientos sin practicar';
                      this.mensaje_no_procede_body = this.global.no_procede_menos_6;
                      //this.MensajeSweet = this.MensajeSweet +' '+ this.result_temp['data']['EstatusMensaje'];
                      //swal("¡Error 1!", this.MensajeSweet, "error");
                    break;
                
                    case '-8'://LA CUENTA TIENE CONVENIO DE PAGO
                      this.global.mostrar = true;
                      this.mostrar_adeudo = 'NoProcede';
                      this.mensaje_no_procede_title = 'Cuenta Predial tiene convenio de pago';
                      this.mensaje_no_procede_body = this.global.no_procede_menos_8;
                      //this.MensajeSweet = this.MensajeSweet +' '+ this.result_temp['data']['EstatusMensaje'];
                      //swal("¡Error 1!", this.MensajeSweet, "error");
                    break;
                
                    case '-9'://CUENTA BLOQUEADA POR JUICIO DE NULIDAD
                      this.global.mostrar = true;
                      this.mostrar_adeudo = 'NoProcede';
                      this.mensaje_no_procede_title = 'Cuenta Predial Bloqueada por juicio de nulidad';
                      this.mensaje_no_procede_body = "<p class='text-justify'>"+this.result_temp['data']['EstatusMensaje']+"</p>";
                      //this.MensajeSweet = this.MensajeSweet +' '+ this.result_temp['data']['EstatusMensaje'];
                      //swal("¡Error 1!", this.MensajeSweet, "error");
                    break;

                    case '-11'://DESCUENTO EXCEDE LIMITE (DEL 18 AL 21 DE NOVIEMBRE); PASAR A JEFATURA DE RECAUDADORA
                      this.global.mostrar = true;
                      this.mostrar_adeudo = 'NoProcede';
                      this.mensaje_no_procede_title = 'Cuenta Predial Bloqueada, descuento excede límite Buen Fin';
                      this.mensaje_no_procede_body = "<p class='text-justify'>"+this.result_temp['data']['EstatusMensaje']+"</p>";
                      //this.MensajeSweet = this.MensajeSweet +' '+ this.result_temp['data']['EstatusMensaje'];
                      //swal("¡Error 1!", this.MensajeSweet, "error");
                    break;
                    
                  }//switch (this.result_temp['tipo']) {
                  
                  this.global.mostrar_consultar = false;
                  //localStorage.clear();
                }else{//if (this.result_temp['status'] === true) {
                  switch (this.result_temp['tipo']) {
                    case '-1': //MANTENIMIENTO PROCESOS
                    case '-3': //MANTENIMIENTO SISTEMAS
                      //this.global.mostrar = false;
                      this.global.mostrar_mantenimiento = true;
                    break;
                    
                    case '-2': //PROCESANDO PAGOS
                      //this.global.mostrar = false;
                      this.global.mostrar_procesando_pagos = true;
                    break;

                    default:
                      this.MensajeSweet = this.result_temp['message'];
                      swal("¡Aviso 5!", this.MensajeSweet, "warning");
                      
                      this.global.mostrar = false;
                    break;
                  }
                  
                  this.datos_adeudos = [];
                  this.datos_bbva = [];
                  this.datos_ecommerce = [];
                  this.datos_mit = [];
                  this.datos_netpay = [];
                  this.global.mostrar = false;
                }//if (this.result_temp['status'] === true) {} else{
              }//if(this.result_temp){
              
              this.spinner.hide();
            } else {//if(this.global.hora_actual.isBefore(this.hora_caducidad) && localStorage.getItem('recaudadora')===this.formConsulta.value.recaudadora && localStorage.getItem('tipo')===this.formConsulta.value.tipo && localStorage.getItem('cuenta')===this.formConsulta.value.cuenta){
              //console.log('consulta');

              localStorage.clear();
              /*
              console.log('this.formConsulta.value.recaudadora:'+this.formConsulta.value.recaudadora);
              console.log('this.formConsulta.value.tipo:'+this.formConsulta.value.tipo);
              console.log('this.formConsulta.value.cuenta:'+this.formConsulta.value.cuenta);
              console.log('this.formConsulta.value.correo:'+this.formConsulta.value.correo);
              
              console.log("localStorage.getItem('recaudadora'):"+localStorage.getItem('recaudadora'));
              console.log("localStorage.getItem('tipo'):"+localStorage.getItem('tipo'));
              console.log("localStorage.getItem('cuenta'):"+localStorage.getItem('cuenta'));
              console.log("localStorage.getItem('correo'):"+localStorage.getItem('correo'));
              */
              
              //console.log('localStorage 1 antes subscribe:');
              //console.log(localStorage);
              
              localStorage.setItem('recaudadora', this.formConsulta.value.recaudadora);
              localStorage.setItem('tipo', this.formConsulta.value.tipo);
              localStorage.setItem('cuenta', this.formConsulta.value.cuenta);
              localStorage.setItem('correo', this.formConsulta.value.correo);

              //console.log('localStorage 2 antes subscribe:');
              //console.log(localStorage);

              this.http.post(this.url+'consulta_adeudo', formData).subscribe((result: any) => {
                /*
                console.log('result:');
                console.log(result);
                */
                
                //console.log('this.global.hora_actual 1:'+this.global.hora_actual);
                //console.log('this.global.hora_actual 2:'+moment(this.global.hora_actual).format());
                this.hora_caducidad = moment(this.global.hora_actual).add(1, 'hours');
                //console.log('this.hora_caducidad 1:'+this.hora_caducidad);
                //console.log('this.hora_caducidad 1:'+moment(this.hora_caducidad).format());

                localStorage.setItem('caducidad_c1', moment(this.hora_caducidad).format());
                localStorage.setItem('caducidad_c2', this.hora_caducidad);
                /*
                console.log("localStorage.getItem('caducidad_c1'):"+localStorage.getItem('caducidad_c1'));
                console.log("localStorage.getItem('caducidad_c2'):"+localStorage.getItem('caducidad_c2'));
                console.log(localStorage);
                */
                result['caducidad_c1'] = localStorage.getItem('caducidad_c1');
                result['caducidad_c2'] = localStorage.getItem('caducidad_c2');

                localStorage.setItem('response', JSON.stringify(result));
                /*
                console.log('localStorage 3 despues subscribe:');
                console.log(localStorage);
                console.log("localStorage.getItem('response') subscribe:");
                console.log(localStorage.getItem('response'));
                */
                
                this.MensajeSweet = (this.MensajeSweet) ? this.MensajeSweet : 'Error';
                
                try {
                  /*
caso
-1 CUENTA INEXISTENTE
0	 CUENTA CON ADEUDO, PROCEDE PAGO
1	 CUENTA PAGADA, NO PROCEDE PAGO
2	 CUENTA EXENTA, NO PROCEDE PAGO
3	 CUENTA CANCELADA
4	 CUENTA BLOQUEADA, PASAR A CATASTRO, NO PROCEDE PAGO
5	 CUENTA PAGADA VIA INTERNET
6	 LA CUENTA TIENE REQUERIMIENTOS SIN PRACTICAR
7	 LA CUENTA TIENE DESCUENTOS ESPECIALES, PROCEDE PAGO
8	 LA CUENTA TIENE CONVENIO DE PAGO
9	 CUENTA BLOQUEADA POR JUICIO DE NULIDAD
10 CUENTA PAGADA ESTABLECIMIENTOS
11 DESCUENTO EXCEDE LIMITE (DEL 18 AL 21 DE NOVIEMBRE); PASAR A JEFATURA DE RECAUDADORA

array('status' => TRUE,  'tipo'=>'5',   'message' => 'CUENTA PREDIAL CON PAGO EN PROCESO DE REVISION',     'data' => ($data_api));//caso 0, 7, 1, 5, 10 PAGO ODOO REGISTRADO, SIN REGISTRO EN INFORMIX
array('status' => TRUE,  'tipo'=>'4',   'message' => 'CUENTA PREDIAL PAGADA, OBTENER RECIBO OFICIAL',      'data' => ($data_api));//caso 0, 7
array('status' => TRUE,  'tipo'=>'3',   'message' => 'CUENTA PREDIAL CON ADEUDO, PROCEDE PAGO',            'data' => ($data_api));//caso 0, 7
array('status' => TRUE,  'tipo'=>'2',   'message' => 'CUENTA PREDIAL CON PAGO EN PROCESO DE REVISION, RE', 'data' => ($data_api));//caso 0, 7
array('status' => TRUE,  'tipo'=>'1',   'message' => 'CUENTA PREDIAL PAGADA',                              'data' => ($data_api));//caso 1, 5, 10
array('status' => TRUE,  'tipo'=>'-1',  'message' => $data_api['EstatusMensaje'],                          'data' => ($data_api));//caso -1	"CUENTA INEXISTENTE"
array('status' => TRUE,  'tipo'=>'-2',  'message' => $data_api['EstatusMensaje'],                          'data' => ($data_api));//caso 2	"CUENTA EXENTA, NO PROCEDE PAGO"
array('status' => TRUE,  'tipo'=>'-3',  'message' => $data_api['EstatusMensaje'],                          'data' => ($data_api));//caso 3	"CUENTA CANCELADA"
array('status' => TRUE,  'tipo'=>'-4',  'message' => $data_api['EstatusMensaje'],                          'data' => ($data_api));//caso 4	"CUENTA BLOQUEADA, PASAR A CATASTRO, NO PROCEDE PAGO"
array('status' => TRUE,  'tipo'=>'-6',  'message' => $data_api['Estatus'],                                 'data' => ($data_api));//caso 6 	"LA CUENTA TIENE REQUERIMIENTOS SIN PRACTICAR"
array('status' => TRUE,  'tipo'=>'-8',  'message' => $data_api['Estatus'],                                 'data' => ($data_api));//caso 8 	"LA CUENTA TIENE CONVENIO DE PAGO"
array('status' => TRUE,  'tipo'=>'-9',  'message' => $data_api['Estatus'],                                 'data' => ($data_api));//caso 9	"CUENTA BLOQUEADA POR JUICIO DE NULIDAD"
array('status' => TRUE,  'tipo'=>'-11', 'message' => $data_api['Estatus'],                                 'data' => ($data_api));//caso 11	"DESCUENTO EXCEDE LIMITE (DEL 18 AL 21 DE NOVIEMBRE); PASAR A JEFATURA DE RECAUDADORA"

array('status' => FALSE, 'tipo'=>'0',  	'message' => 'ERROR PROCESAMIENTO 4',  						                 'data' => array('error' => $data['datos']['error_numero']));
array('status' => FALSE, 'tipo'=>'0',  	'message' => 'ERROR PROCESAMIENTO 3',  						                 'data' => ($data_api));
array('status' => FALSE, 'tipo'=>'0',  	'message' => 'ERROR PROCESAMIENTO 2',  						                 'data' => ($data_api));
array('status' => FALSE, 'tipo'=>'0',   'message' => 'ERROR PROCESAMIENTO 1',  						                 'data' => ($data_api));
array('status' => FALSE, 'tipo'=>'-1',  'message' => 'MANTENIMIENTO PROCESOS', 						                 'data' => ($data_api));
array('status' => FALSE, 'tipo'=>'-2',  'message' => 'PROCESANDO PAGOS',       						                 'data' => ($data_api));
array('status' => FALSE, 'tipo'=>'-3',  'message' => 'MANTENIMIENTO SISTEMAS', 						                 'data' => ($data_api));
array('status' => FALSE, 'tipo'=>'-10', 'message' => 'CUENTA PREDIAL SIN ESTATUS',                         'data' => ($data_api));
                  */
                  if (result.status === true) {
                    //alert('consulta desde api');

                    switch (result.tipo) {
                      case '1'://CUENTA PREDIAL PAGADA
                      case '2'://CUENTA PREDIAL CON PAGO EN PROCESO DE REVISION, RE
                      case '4'://CUENTA PREDIAL PAGADA, OBTENER RECIBO OFICIAL
                      case '5'://CUENTA PREDIAL CON PAGO EN PROCESO DE REVISION
                        if(result.data['presupuesto']){
                          this.presupuesto = result.data['presupuesto'];
                          this.presupuesto_params_encriptado = result.data['presupuesto_params_encriptado'];
                          this.presupuesto_url = result.data['presupuesto_url'];
    
                          this.url_valida_presupuesto_participativo = this.global.url_presupuesto_participativo + this.presupuesto_params_encriptado;
                          //alert('this.presupuesto_url:'+this.presupuesto_url);
                          //alert('this.url_valida_presupuesto_participativo:'+this.url_valida_presupuesto_participativo);
                          //alert('this.params_ventana_presupuesto_participativo:'+this.params_ventana_presupuesto_participativo);
                          if(this.url_valida_presupuesto_participativo == this.presupuesto_url){
                            //window.open(this.presupuesto_url, this.params_ventana_presupuesto_participativo);
                            //setTimeout(() => window.open(this.presupuesto_url, this.params_ventana_presupuesto_participativo), 3000);
                            setTimeout(() => this.global.abre_ventana(this.presupuesto_url));
                            //window.open(this.presupuesto_url, '_self');
                          }
                        }else{//if(result.data['presupuesto']){
                          //alert('no mostrar presupuesto participativo');
                        }//if(result.data['presupuesto']){}else{
                        
                        this.mostrar_adeudo = 'Pagado';
                        this.global.mostrar = true;
                        this.ClaveCatastral = result.data['ClaveCatastral'];
                        this.IdCuenta = result.data['IdCuenta'];
                        this.Calle = result.data['Calle'];
                        this.Colonia = result.data['Colonia'];
                        this.NoExterior = result.data['NoExterior'];
                        //////this.NoExterior = parseInt(result.data['NoExterior']);
                        //////this.NoExterior = this.NoExterior > 0 ? this.NoExterior.toString() : "";
                        this.NoInterior = result.data['NoInterior'];
                        //////this.NoInterior = parseInt(result.data['NoInterior']);
                        //////this.NoInterior = this.NoInterior > 0 ? this.NoInterior.toString() : "";
                        this.MtsTerreno = result.data['MtsTerreno'];
                        this.MtsConstruccion = result.data['MtsConstruccion'];
                        this.ValorTerreno = result.data['ValorTerreno'];
                        this.ValorConstruccion = result.data['ValorConstruccion'];
                        this.ValorCatastral = result.data['ValorCatastral'];
                        this.MensajePago = result.data['EstatusMensaje'];
                        this.LugarPago = result.data['LugarPago'];
                        this.fecha_limite = result.data['fecha_limite'];
                        this.s_transm = result.data['s_transm'];
                        this.linea_captura = result.data['linea_captura'];
                        this.importe = result.data['importe'];
                        this.mp_signature = result.data['mp_signature'];
                        this.pagos = result.data.pagos;
                      break;

                      case '3'://CUENTA PREDIAL CON ADEUDO, PROCEDE PAGO
                        this.mostrar_adeudo = 'Adeudo';
                        this.global.mostrar = true;
                        this.mostrar_opc_pago = true;
                        this.ClaveCatastral = result.data['ClaveCatastral'];
                        this.IdCuenta = result.data['IdCuenta'];
                        this.Calle = result.data['Calle'];
                        this.Colonia = result.data['Colonia'];
                        this.NoExterior = result.data['NoExterior'];
                        //////this.NoExterior = parseInt(result.data['NoExterior']);
                        //////this.NoExterior = this.NoExterior > 0 ? this.NoExterior.toString() : "";
                        this.NoInterior = result.data['NoInterior'];
                        //////this.NoInterior = parseInt(result.data['NoInterior']);
                        //////this.NoInterior = this.NoInterior > 0 ? this.NoInterior.toString() : "";
                        this.MtsTerreno = result.data['MtsTerreno'];
                        this.MtsConstruccion = result.data['MtsConstruccion'];
                        this.ValorTerreno = result.data['ValorTerreno'];
                        this.ValorConstruccion = result.data['ValorConstruccion'];
                        this.ValorCatastral = result.data['ValorCatastral'];
                        this.MensajeAfectacion = result.data['MensajeAfectacion'];
                        this.MensajeSubsidios = result.data['MensajeSubsidios'];
                        this.MensajeFechaLimite = result.data['MensajeFechaLimite'];
                        this.fecha_limite = result.data['fecha_limite'];
                        this.icebl = result.data['icebl'];
                        this.datos_adeudos = result.data['adeudos'];
                        //console.log(typeof result.data['bbva']);
                        /*if (typeof result.data['bbva'] !== 'undefined') {
                          this.datos_bbva = result.data['bbva'];
                        }*//*else{
                          this.datos_bbva = [];
                          delete this.datos_bbva;
                        }*/
                        this.datos_bbva = result.data['bbva'];
                        this.datos_ecommerce = result.data['ecommerce'];
                        this.datos_mit = result.data['mit'];
                        this.datos_netpay = result.data['netpay'];
                        this.amount = this.datos_ecommerce['amount'];
                        this.id = this.datos_ecommerce['id'];
                        this.s_transm = result.data['s_transm'];
                        this.linea_captura = result.data['linea_captura'];
                        this.importe = result.data['importe'];
                        this.mp_signature = result.data['mp_signature'];
                        this.pagos = result.data.pagos;
                      break;

                      case '-1'://CUENTA INEXISTENTE
                        this.global.mostrar = true;
                        this.mostrar_adeudo = 'NoProcede';
                        this.mensaje_no_procede_title = 'Cuenta Predial Inexistente';
                        this.mensaje_no_procede_body = this.global.no_procede_menos_1;
                        //this.MensajeSweet = this.MensajeSweet +' '+ result.message;
                        //swal("¡Error 1!", this.MensajeSweet, "error");

                        /*
                        this.MensajeSweet = this.MensajeSweet +' '+ result.message;
                        this.mostrar_adeudo = 'Inexistente';
                        this.global.mostrar = false;
                        swal("¡Error 1!", this.MensajeSweet, "error");
                        */
                      break;

                      case '-2'://CUENTA EXENTA, NO PROCEDE PAGO
                        this.global.mostrar = true;
                        this.mostrar_adeudo = 'NoProcede';
                        this.mensaje_no_procede_title = 'Cuenta Predial Exenta, no procede pago';
                        this.mensaje_no_procede_body = this.global.no_procede_menos_2;
                        //this.MensajeSweet = this.MensajeSweet +' '+ result.message;
                        //swal("¡Error 1!", this.MensajeSweet, "error");
                      break;

                      case '-3'://CUENTA CANCELADA
                        this.global.mostrar = true;
                        this.mostrar_adeudo = 'NoProcede';
                        this.mensaje_no_procede_title = 'Cuenta Predial Cancelada';
                        this.mensaje_no_procede_body = this.global.no_procede_menos_3;
                        //this.MensajeSweet = this.MensajeSweet +' '+ result.message;
                        //swal("¡Error 1!", this.MensajeSweet, "error");
                      break;

                      case '-4'://CUENTA BLOQUEADA, PASAR A CATASTRO, NO PROCEDE PAGO
                        this.global.mostrar = true;
                        this.mostrar_adeudo = 'NoProcede';
                        this.mensaje_no_procede_title = 'Cuenta Predial Bloqueada, pasar a catastro, no procede pago';
                        this.mensaje_no_procede_body = this.global.no_procede_menos_4;
                        //this.MensajeSweet = this.MensajeSweet +' '+ result.message;
                        //swal("¡Error 1!", this.MensajeSweet, "error");
                      break;

                      case '-6'://LA CUENTA TIENE REQUERIMIENTOS SIN PRACTICAR
                        this.global.mostrar = true;
                        this.mostrar_adeudo = 'NoProcede';
                        this.mensaje_no_procede_title = 'Cuenta Predial tiene requerimientos sin practicar';
                        this.mensaje_no_procede_body = this.global.no_procede_menos_6;
                        //this.MensajeSweet = this.MensajeSweet +' '+ result.message;
                        //swal("¡Error 1!", this.MensajeSweet, "error");
                      break;

                      case '-8'://LA CUENTA TIENE CONVENIO DE PAGO
                        this.global.mostrar = true;
                        this.mostrar_adeudo = 'NoProcede';
                        this.mensaje_no_procede_title = 'Cuenta Predial tiene convenio de pago';
                        this.mensaje_no_procede_body = this.global.no_procede_menos_8;
                        //this.MensajeSweet = this.MensajeSweet +' '+ result.message;
                        //swal("¡Error 1!", this.MensajeSweet, "error");
                      break;

                      case '-9'://CUENTA BLOQUEADA POR JUICIO DE NULIDAD
                        this.global.mostrar = true;
                        this.mostrar_adeudo = 'NoProcede';
                        this.mensaje_no_procede_title = 'Cuenta Predial Bloqueada por juicio de nulidad';
                        this.mensaje_no_procede_body = "<p class='text-justify'>"+result.message+"</p>";
                        //this.MensajeSweet = this.MensajeSweet +' '+ result.message;
                        //swal("¡Error 1!", this.MensajeSweet, "error");
                      break;

                      case '-11'://DESCUENTO EXCEDE LIMITE (DEL 18 AL 21 DE NOVIEMBRE); PASAR A JEFATURA DE RECAUDADORA
                        this.global.mostrar = true;
                        this.mostrar_adeudo = 'NoProcede';
                        this.mensaje_no_procede_title = 'Cuenta Predial Bloqueada, descuento excede límite Buen Fin';
                        this.mensaje_no_procede_body = "<p class='text-justify'>"+result.message+"</p>";
                        //this.MensajeSweet = this.MensajeSweet +' '+ result.message;
                        //swal("¡Error 1!", this.MensajeSweet, "error");
                      break;
                      
                    }//switch (result.tipo) {

                    this.global.mostrar_consultar = false;
                  }else{//if (result.status === true) {
                    switch (result.tipo) {
                      case '-1': //MANTENIMIENTO PROCESOS
                      case '-3': //MANTENIMIENTO SISTEMAS
                        //this.global.mostrar = false;
                        this.global.mostrar_mantenimiento = true;
                      break;
                      
                      case '-2': //PROCESANDO PAGOS
                        //this.global.mostrar = false;
                        this.global.mostrar_procesando_pagos = true;
                      break;

                      default:
                        this.MensajeSweet = result.message;
                        swal("¡Aviso 4!", this.MensajeSweet, "warning");
                        
                        this.global.mostrar = false;
                      break;
                    }
                    
                    this.datos_adeudos = [];
                    this.datos_bbva = [];
                    this.datos_ecommerce = [];
                    this.datos_mit = [];
                    this.datos_netpay = [];
                    this.global.mostrar = false;
                  }//if (result.status === true) {} else{
                  
                  this.spinner.hide();
                } catch (error) {//try {
                  this.spinner.hide();
                  this.cookieService.deleteAll();
                }//try {} catch{
              });//this.http.post(this.url+'consulta_adeudo', formData).subscribe((result: any) => {
            
            }//if(this.global.hora_actual.isBefore(this.hora_caducidad) && localStorage.getItem('recaudadora')===this.formConsulta.value.recaudadora && localStorage.getItem('tipo')===this.formConsulta.value.tipo && localStorage.getItem('cuenta')===this.formConsulta.value.cuenta){
            
          } else { swal("¡Aviso!", "La cuenta es un campo obligatorio.", "warning"); }
        } else { swal("¡Aviso!", "El tipo es un campo obligatorio.", "warning"); }
      } else { swal("¡Aviso!", "La recaudadora es un campo obligatorio.", "warning"); }
    } else {//if(this.respuesta){//CAPTCHA
      swal("¡Aviso!", "Marca la casilla para confirmar que no eres un robot.", "warning");
    }//if(this.respuesta){} else{//CAPTCHA
  }//consultar(){
  
  limpiar(){
    this.global.mostrar = false;
    this.global.mostrar_mantenimiento = false;
    this.global.mostrar_procesando_pagos = false;
    this.global.mostrar_consultar = true;
    this.mostrar_adeudo = '';
    this.ClaveCatastral = '';
    this.IdCuenta = '';
    this.Calle = '';
    this.Colonia = '';
    this.NoExterior = '';
    this.NoInterior = '';
    this.MtsTerreno = '';
    this.MtsConstruccion = '';
    this.ValorTerreno = '';
    this.ValorConstruccion = '';
    this.ValorCatastral = '';
    this.MensajeAfectacion = '';
    this.MensajeSubsidios = '';
    this.MensajeFechaLimite = '';
    this.fecha_limite = '';
    this.MensajePago = '';
    this.datos_adeudos = [];
    this.datos_bbva = [];
    this.datos_ecommerce = [];
    this.datos_mit = [];
    this.datos_netpay = [];
    this.pagos = [];
    this.amount = '';
    this.id = '';
    this.LugarPago = '';
    this.icebl = '';
    this.origen = '';
    this.s_transm = '';
    this.linea_captura = '';
    this.importe = '';
    this.mp_signature = '';
  }//limpiar(){

  orden_pago(){
    this.global.validaHoraServicio();
    window.open(this.url_pdf+'ordenpago/'+this.formConsulta.value.recaudadora+'/'+this.formConsulta.value.tipo+'/'+this.formConsulta.value.cuenta+'/0', 'popup', 'width=600,height=600');
  }//orden_pago(){

  replica_ecommerce(){
    this.global.validaHoraServicio();
    window.open('https://apipagoenlinea.guadalajara.gob.mx/predialApiTest/test_replicar_regreso_ecommerce', 'popup', 'width=600,height=600');
  }//replica_ecommerce(){
  
  envia_bancos(banco){
    this.global.validaHoraServicio();

    //alert("envio:"+banco);
    if(banco == "ecommerce"){
      var myForm = <HTMLFormElement>document.getElementById('form_ecommerce');
    }else{
      if(banco == "mit"){
        var myForm = <HTMLFormElement>document.getElementById('form_mit');
      }else{
        if(banco == "netpay"){
          //var myForm = <HTMLFormElement>document.getElementById('form_netpay');
        }else{
          var myForm = <HTMLFormElement>document.getElementById('form_bbva');
        }
        
      }
      
    }

    const formData = new FormData();
    formData.append('recaudadora', this.formConsulta.value.recaudadora);
    formData.append('tipo', this.formConsulta.value.tipo);
    formData.append('cuenta', this.formConsulta.value.cuenta);
    formData.append('correo', this.formConsulta.value.correo);
    formData.append('fecha_limite', this.fecha_limite);
    formData.append('banco', banco);
    formData.append('version', this.global.version_system);

    this.http.post(this.url+'consulta_web_status', formData).subscribe((result: any) => {
      
      this.MensajeSweet = (this.MensajeSweet) ? this.MensajeSweet : 'Error';
      
      try {
        /*
        array('status' => TRUE, 'tipo'=>'1',   'message' => 'PROCEDE PAGO',                            'data' => NULL);
        array('status' => FALSE, 'tipo'=>'0',  'message' => 'SOLO CONSULTA, NO PROCEDE PAGO',          'data' => NULL);
        array('status' => FALSE, 'tipo'=>'-1', 'message' => 'MANTENIMIENTO PROCESOS, NO PROCEDE PAGO', 'data' => NULL);
        array('status' => FALSE, 'tipo'=>'-2', 'message' => 'PROCESANDO PAGOS',                        'data' => NULL);
        array('status' => FALSE, 'tipo'=>'-3', 'message' => 'MANTENIMIENTO SISTEMAS, NO PROCEDE PAGO', 'data' => NULL);
        array('status' => FALSE, 'tipo'=>'-4', 'message' => 'ERROR EN TIEMPO O FECHA',                 'data' => NULL);
        array('status' => FALSE, 'tipo'=>'-5', 'message' => 'FECHA LIMITE VENCIDA',                    'data' => NULL);
        */
        if (result.status === true) {          

          if(banco == "ecommerce"){
            
            //alert("ecommerce");
            this.origen = '175';
            myForm.submit();//ENVIO FORM ECOMMERCE

          }else{//if(banco == "ecommerce"){

            if(banco == "mit" || banco == "netpay" || banco == "bbva"){
              
              if(banco == "mit"){
              
                //alert("mit");
                this.origen = '174';
  
              }//if(banco == "mit"){
              
              if(banco == "netpay"){
              
                //alert("netpay");
                //alert(this.datos_netpay['hostedCheckoutUrl']);
                this.origen = '178';
  
              }//if(banco == "netpay"){
              
              if(banco == "bbva"){
            
                //alert("bbva");
                this.origen = '102';
  
              }//if(banco == "bbva"){
              
              //alert("MIT/NETPAY/BBVA enviar guardar envio bancos");
              const formDataGuardarEnvioBancos = new FormData();
              /*
              formDataGuardarEnvioBancos.append('s_transm', this.datos_bbva['s_transm']);
              formDataGuardarEnvioBancos.append('lineaCaptura', this.datos_bbva['r_bancaria']);
              formDataGuardarEnvioBancos.append('importe', this.datos_bbva['t_importe']);
              formDataGuardarEnvioBancos.append('mp_signature', this.datos_bbva['mp_signature']);
              */
              formDataGuardarEnvioBancos.append('s_transm', this.s_transm);
              formDataGuardarEnvioBancos.append('lineaCaptura', this.linea_captura);
              formDataGuardarEnvioBancos.append('importe', this.importe);
              formDataGuardarEnvioBancos.append('mp_signature', this.mp_signature);
              formDataGuardarEnvioBancos.append('idConsultaEnvioBancoLog', this.icebl);
              formDataGuardarEnvioBancos.append('origen', this.origen);

              this.http.post(this.url+'guardar_envio_bancos', formDataGuardarEnvioBancos).subscribe((result2: any) => {
                
                this.MensajeSweet = (this.MensajeSweet) ? this.MensajeSweet : 'Error';
                
                try { 
                  //alert(result2.status);
                  //console.log(result2.status);
                  /*
                  array('status' => TRUE,  'tipo'=>'1',  'message' => 'ENVIO EXITOSO',          'data' => ($data_api));
                  array('status' => FALSE, 'tipo'=>'0',  'message' => 'ERROR PROCESAMIENTO',    'data' => ($data_api));
                  array('status' => FALSE, 'tipo'=>'-1', 'message' => 'MANTENIMIENTO PROCESOS', 'data' => ($data_api));
                  array('status' => FALSE, 'tipo'=>'-2', 'message' => 'PROCESANDO PAGOS',       'data' => ($data_api));
                  array('status' => FALSE, 'tipo'=>'-3', 'message' => 'MANTENIMIENTO SISTEMAS', 'data' => ($data_api));
                  */
                  if (result2.status === true) {
                    if(banco == "netpay"){
              
                      //alert("envio a netpay");
                      //alert(this.datos_netpay['hostedCheckoutUrl']);
                      document.location.href = this.datos_netpay['hostedCheckoutUrl'];
                    }else{
                      //alert("envio a mit/bbva");
                      myForm.submit();//ENVIO FORM MIT/BBVA
                    }//if(banco == "netpay"){
                    
                  }else{//if (result.status === true) {
                    
                    this.MensajeSweet = result2.message;
                    swal("¡Aviso 3!", this.MensajeSweet, "warning");
                    
                    this.datos_adeudos = [];
                    this.datos_bbva = [];
                    this.datos_ecommerce = [];
                    this.datos_mit = [];
                    this.datos_netpay = [];
                    this.global.mostrar = false;
                  }//if (result.status === true) {} else{
                  
                  this.spinner.hide();
                } catch (error) {//try {
                  this.spinner.hide();
                  this.cookieService.deleteAll();
                }//try {} catch{
              });//this.http.post(this.url+'consulta_adeudo', formDataGuardarEnvioBancos).subscribe((result: any) => {
              
            }//if(banco == "mit" || banco == "netpay" || banco == "bbva"){

          }//if(banco == "ecommerce"){}else{

        }else{//if (result.status === true) {
          this.datos_adeudos = [];
          this.datos_bbva = [];
          this.datos_ecommerce = [];
          this.datos_mit = [];
          this.datos_netpay = [];
          //this.global.mostrar = false;
          /*
          array('status' => TRUE, 'tipo'=>'1',   'message' => 'PROCEDE PAGO',                            'data' => NULL);
          array('status' => FALSE, 'tipo'=>'0',  'message' => 'SOLO CONSULTA, NO PROCEDE PAGO',          'data' => NULL);
          array('status' => FALSE, 'tipo'=>'-1', 'message' => 'MANTENIMIENTO PROCESOS, NO PROCEDE PAGO', 'data' => NULL);
          array('status' => FALSE, 'tipo'=>'-2', 'message' => 'PROCESANDO PAGOS',                        'data' => NULL);
          array('status' => FALSE, 'tipo'=>'-3', 'message' => 'MANTENIMIENTO SISTEMAS, NO PROCEDE PAGO', 'data' => NULL);
          array('status' => FALSE, 'tipo'=>'-4', 'message' => 'ERROR EN TIEMPO O FECHA',                 'data' => NULL);
          array('status' => FALSE, 'tipo'=>'-5', 'message' => 'FECHA LIMITE VENCIDA',                    'data' => NULL);
          */
          switch (result.tipo) {
            case '0'://SOLO CONSULTA, NO PROCEDE PAGO
              //this.global.mostrar = false;
              //this.global.mostrar_mantenimiento = true;
              this.mostrar_opc_pago = false;
              this.MensajeSweet = result.message;
              swal("¡Aviso 1!", this.MensajeSweet, "warning");
            break;           
            
            case '-1': //MANTENIMIENTO PROCESOS, NO PROCEDE PAGO
            case '-3': //MANTENIMIENTO SISTEMAS, NO PROCEDE PAGO
              this.global.mostrar = false;
              this.global.mostrar_mantenimiento = true;
            break;

            case '-2': //PROCESANDO PAGOS
              this.global.mostrar = false;
              this.global.mostrar_procesando_pagos = true;
            break;

            default:
              //this.global.mostrar = false;
              this.MensajeSweet = result.message;
              swal("¡Aviso 0!", this.MensajeSweet, "warning");
            break;
          }//switch (result.tipo) {
        }//if (result.status === true) {} else{
        
        this.spinner.hide();
      } catch (error) {//try {
        this.spinner.hide();
        this.cookieService.deleteAll();
      }//try {} catch{
    });//this.http.post(this.url+'consulta_adeudo', formData).subscribe((result: any) => {
      
  }//envia_bancos(banco){
     
  envia_bancos_old(banco){
    this.global.validaHoraServicio();

    //alert("envio:"+banco);
    if(banco == "ecommerce"){
      var myForm = <HTMLFormElement>document.getElementById('form_ecommerce');
    }else{
      var myForm = <HTMLFormElement>document.getElementById('form_bbva');
    }

    const formData = new FormData();
    formData.append('recaudadora', this.formConsulta.value.recaudadora);
    formData.append('tipo', this.formConsulta.value.tipo);
    formData.append('cuenta', this.formConsulta.value.cuenta);
    formData.append('correo', this.formConsulta.value.correo);
    formData.append('fecha_limite', this.fecha_limite);
    formData.append('banco', banco);
    formData.append('version', this.global.version_system);

    this.http.post(this.url+'consulta_web_status', formData).subscribe((result: any) => {
      
      this.MensajeSweet = (this.MensajeSweet) ? this.MensajeSweet : 'Error';
      
      try {
        /*
        array('status' => TRUE, 'tipo'=>'1',   'message' => 'PROCEDE PAGO',                            'data' => NULL);
        array('status' => FALSE, 'tipo'=>'0',  'message' => 'SOLO CONSULTA, NO PROCEDE PAGO',          'data' => NULL);
        array('status' => FALSE, 'tipo'=>'-1', 'message' => 'MANTENIMIENTO PROCESOS, NO PROCEDE PAGO', 'data' => NULL);
        array('status' => FALSE, 'tipo'=>'-2', 'message' => 'PROCESANDO PAGOS',                        'data' => NULL);
        array('status' => FALSE, 'tipo'=>'-3', 'message' => 'MANTENIMIENTO SISTEMAS, NO PROCEDE PAGO', 'data' => NULL);
        array('status' => FALSE, 'tipo'=>'-4', 'message' => 'ERROR EN TIEMPO O FECHA',                 'data' => NULL);
        array('status' => FALSE, 'tipo'=>'-5', 'message' => 'FECHA LIMITE VENCIDA',                    'data' => NULL);
        */
        if (result.status === true) {
          if(banco == "ecommerce"){
            myForm.submit();//ENVIO FORM ECOMMERCE
          }else{
            //alert("BBVA eviar guardar envio bancos");
            const formDataGuardarEnvioBancos = new FormData();

            formDataGuardarEnvioBancos.append('s_transm', this.datos_bbva['s_transm']);
            formDataGuardarEnvioBancos.append('lineaCaptura', this.datos_bbva['r_bancaria']);
            formDataGuardarEnvioBancos.append('importe', this.datos_bbva['t_importe']);
            formDataGuardarEnvioBancos.append('idConsultaEnvioBancoLog', this.icebl);
            formDataGuardarEnvioBancos.append('origen', '102');

            this.http.post(this.url+'guardar_envio_bancos', formDataGuardarEnvioBancos).subscribe((result2: any) => {
              
              this.MensajeSweet = (this.MensajeSweet) ? this.MensajeSweet : 'Error';
              
              try { 
                //alert(result2.status);
                //console.log(result2.status);
                /*
                array('status' => TRUE,  'tipo'=>'1',  'message' => 'ENVIO EXITOSO',          'data' => ($data_api));
                array('status' => FALSE, 'tipo'=>'0',  'message' => 'ERROR PROCESAMIENTO',    'data' => ($data_api));
                array('status' => FALSE, 'tipo'=>'-1', 'message' => 'MANTENIMIENTO PROCESOS', 'data' => ($data_api));
                array('status' => FALSE, 'tipo'=>'-2', 'message' => 'PROCESANDO PAGOS',       'data' => ($data_api));
                array('status' => FALSE, 'tipo'=>'-3', 'message' => 'MANTENIMIENTO SISTEMAS', 'data' => ($data_api));
                */
                if (result2.status === true) {
                  myForm.submit();//ENVIO FORM BBVA
                }else{//if (result.status === true) {
                  
                  this.MensajeSweet = result2.message;
                  swal("¡Aviso 3!", this.MensajeSweet, "warning");
                  
                  this.datos_adeudos = [];
                  this.datos_bbva = [];
                  this.datos_ecommerce = [];
                  this.datos_mit = [];
                  this.datos_netpay = [];
                  this.global.mostrar = false;
                }//if (result.status === true) {} else{
                
                this.spinner.hide();
              } catch (error) {//try {
                this.spinner.hide();
                this.cookieService.deleteAll();
              }//try {} catch{
            });//this.http.post(this.url+'consulta_adeudo', formDataGuardarEnvioBancos).subscribe((result: any) => {
          }

        }else{//if (result.status === true) {
          this.datos_adeudos = [];
          this.datos_bbva = [];
          this.datos_ecommerce = [];
          this.datos_mit = [];
          this.datos_netpay = [];
          //this.global.mostrar = false;
          /*
          array('status' => TRUE, 'tipo'=>'1',   'message' => 'PROCEDE PAGO',                            'data' => NULL);
          array('status' => FALSE, 'tipo'=>'0',  'message' => 'SOLO CONSULTA, NO PROCEDE PAGO',          'data' => NULL);
          array('status' => FALSE, 'tipo'=>'-1', 'message' => 'MANTENIMIENTO PROCESOS, NO PROCEDE PAGO', 'data' => NULL);
          array('status' => FALSE, 'tipo'=>'-2', 'message' => 'PROCESANDO PAGOS',                        'data' => NULL);
          array('status' => FALSE, 'tipo'=>'-3', 'message' => 'MANTENIMIENTO SISTEMAS, NO PROCEDE PAGO', 'data' => NULL);
          array('status' => FALSE, 'tipo'=>'-4', 'message' => 'ERROR EN TIEMPO O FECHA',                 'data' => NULL);
          array('status' => FALSE, 'tipo'=>'-5', 'message' => 'FECHA LIMITE VENCIDA',                    'data' => NULL);
          */
          switch (result.tipo) {
            case '0'://SOLO CONSULTA, NO PROCEDE PAGO
              //this.global.mostrar = false;
              //this.global.mostrar_mantenimiento = true;
              this.mostrar_opc_pago = false;
              this.MensajeSweet = result.message;
              swal("¡Aviso 1!", this.MensajeSweet, "warning");
            break;           
            
            case '-1': //MANTENIMIENTO PROCESOS, NO PROCEDE PAGO
            case '-3': //MANTENIMIENTO SISTEMAS, NO PROCEDE PAGO
              this.global.mostrar = false;
              this.global.mostrar_mantenimiento = true;
            break;

            case '-2': //PROCESANDO PAGOS
              this.global.mostrar = false;
              this.global.mostrar_procesando_pagos = true;
            break;

            default:
              //this.global.mostrar = false;
              this.MensajeSweet = result.message;
              swal("¡Aviso 0!", this.MensajeSweet, "error");
            break;
          }//switch (result.tipo) {
        }//if (result.status === true) {} else{
        
        this.spinner.hide();
      } catch (error) {//try {
        this.spinner.hide();
        this.cookieService.deleteAll();
      }//try {} catch{
    });//this.http.post(this.url+'consulta_adeudo', formData).subscribe((result: any) => {
    
  }//envia_bancos_old(banco){

  valida_numeros(event){
    if((event.keyCode>=48 && event.keyCode<=57)|| (event.keyCode >= 96 && event.keyCode <= 105) || event.keyCode===8 || event.keyCode===46 || event.keyCode===37 || event.keyCode===39 || event.keyCode===9 || event.keyCode == 118 || event.keyCode == 86 /*(event.ctrlKey==true && (event.keyCode == 118 || event.keyCode == 86))*/){ return true; } 
    else { return false; }
  }//valida_numeros(event){
}